<div style="margin-top: 50px">
    <div class="table-container" style="margin-top: 16px; margin-bottom: 150px;">

        <app-ag-pagination-toolbar [totalRows]="totalRowCount" [currentPageSize]="gridOptions.cacheBlockSize"
            [currentPage]="currentPage" (pageSizeChange)="onPageSizeChanged($event)" (goToPage)="onGoToPage($event)"
            (exportCsv)="onExport()" [showGenerateAvails]="false">
        </app-ag-pagination-toolbar>

        <ag-grid-angular class="ag-theme-alpine" style="height: 600px;" [gridOptions]="gridOptions"
            [columnDefs]="columnDefs" (gridReady)="onGridReady($event)">
        </ag-grid-angular>


        <div class="nbcu-loader" *ngIf="loadingService.isLoading()"></div>
    </div>
</div>
